import { CoreDialog, CoreDialogContent, CoreTypography } from '@youscience/core';

import useHomePageStore from '@store/HomePageStore';
import { Completion } from '@interfaces/adminHomePage';
import DialogFooter from '@components/DialogFooter';

import { sxStyles } from './AreaDeleteMessage.styles';

interface AreaDeleteMessageProps {
  areaTitle: string;
  areaCipCode: number;
  isOpenAreaDeleteMessage: boolean;
  onCloseAreaDeleteMessage: () => void;
}

export const AreaDeleteMessage = (props: AreaDeleteMessageProps) => {
  const { areaTitle, areaCipCode, isOpenAreaDeleteMessage, onCloseAreaDeleteMessage } = props;

  const {
    adminHomePageData: {
      school: { completions },
    },
    updateAdminHomePageData,
  } = useHomePageStore((state) => state);

  const handleDeleteSchool = async () => {
    const preparedCompletion = completions.reduce((acc, item) => {
      const cipCode = Math.floor(+item.cipCode);

      if (areaCipCode === cipCode) {
        return [...acc, { cipCode: item.cipCode, awLevel: null }];
      }
      return [...acc, item];
    }, [] as Completion[]);

    await updateAdminHomePageData(
      { completions: preparedCompletion },
      `${areaTitle} with majors removed for your college.`,
    );

    onCloseAreaDeleteMessage();
  };

  return (
    <CoreDialog sx={sxStyles.wrap} open={isOpenAreaDeleteMessage}>
      <CoreDialogContent sx={sxStyles.content}>
        <CoreTypography sx={sxStyles.title} variant="h5" component="h4">
          {`Remove the ${areaTitle}`}
        </CoreTypography>

        <CoreTypography>
          {`You are about to remove an area of study including majors for your school. Are you sure you want to remove the area of study ${areaTitle} from the list of offered by your school?`}
        </CoreTypography>
      </CoreDialogContent>

      <DialogFooter
        goBackButtonTitle="Cancel"
        goNextButtonTitle="Remove"
        goNextActionButtonTitle="Removing"
        onGoBack={onCloseAreaDeleteMessage}
        onGoNext={handleDeleteSchool}
      />
    </CoreDialog>
  );
};
